import { css } from 'styled-components';

export default css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
